import styles from '../InternalExternalDetail.module.css'
import Icon from './Icon'
import Button from './Button'

const NoteCard = ({ type, text, author, posted, date, onEdit, onDelete }) => (
  <div className={styles.noteCard}>
    <div className={styles.noteAvatar}>
      <Icon name="user" />
    </div>

    <div className={styles.noteBody}>
      <p className={styles.noteText}>{text}</p>
      <p className={styles.noteAuthor}>{author}</p>
    </div>

    {type === 'date' ? (
      <div className={styles.noteSide}>
        <span className={styles.dateBadge}>
          <Icon name="clock" className={styles.dateBadgeIcon} />
          <span>{date}</span>
        </span>
        <span className={styles.postedText}>{posted}</span>
      </div>
    ) : (
      <div className={styles.noteSide}>
        <div className={styles.noteActions}>
          <Button variant="smallIconBtn" icon="edit"  onClick={onEdit} />
          <Button variant="smallIconBtn" icon="trash" onClick={onDelete} />
        </div>
        <span className={styles.postedText}>{posted}</span>
      </div>
    )}
  </div>
)

export default NoteCard
